/**
 * Text for places that render HTML (e.g. SettingsConfirmModal's description):
 * file names and other typed text must not become markup (QA batch 15).
 */
export const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
